export const daysData = () => [
  {
    value: 1,
    day: 'Monday',
    dayShort: 'Mon'
  },
  {
    value: 2,
    day: 'Tuesday',
    dayShort: 'Tue'
  },
  {
    value: 3,
    day: 'Wednesday',
    dayShort: 'Wed'
  },
  {
    value: 4,
    day: 'Thursday',
    dayShort: 'Thu'
  },
  {
    value: 5,
    day: 'Friday',
    dayShort: 'Fri'
  },
  {
    value: 6,
    day: 'Saturday',
    dayShort: 'Sat'
  },
  {
    value: 0,
    day: 'Sunday',
    dayShort: 'Sun'
  }
]

export const embedHours = (branch) => {
  const days = daysData()
  days[0].time = branch.mon
  days[1].time = branch.tue
  days[2].time = branch.wed
  days[3].time = branch.thu
  days[4].time = branch.fri
  days[5].time = branch.sat
  days[6].time = branch.sun

  return days
}



// WEBPACK FOOTER //
// ./src/helpers/BranchesHelper.js